<script lang="ts" setup></script>

<template>
    <span class="mx-4 max-w-sm text-center sm:mx-0 sm:max-w-full sm:text-left">
        <h1
            class="max-w-fit overflow-hidden text-ellipsis bg-gradient-to-tr from-white via-white to-yellow-200 bg-clip-text text-3xl font-black text-transparent drop-shadow"
        >
            <slot />
        </h1>
    </span>
</template>

<style scoped></style>
